
import SettingsHub from "./SettingsHub";

export default function SettingsPage() {
  return <SettingsHub />;
}

